import cadviewer from "cadviewer";

export const getSelectedSpaces = (multiSelectArray: string[]): string[] => {
  try {
    // Get multi-selected spaces from CADViewer
    const multiSelectList = cadviewer.cvjs_getMultiSelectArray() as any[];

    // Combine all selected spaces
    const allSelectedSpaces: string[] = [];

    // Add from multiSelectArray (from context - drag selected)
    if (multiSelectArray && multiSelectArray.length > 0) {
      allSelectedSpaces.push(...multiSelectArray);
    }

    // Add from CADViewer multi-select
    if (multiSelectList && multiSelectList.length > 0) {
      multiSelectList.forEach((space: any) => {
        if (space?.SpaceID) {
          allSelectedSpaces.push(space.SpaceID);
        }
      });
    }

    // Remove duplicates
    const uniqueSpaces = Array.from(new Set(allSelectedSpaces));

    return uniqueSpaces;
  } catch (error) {
    console.error("Error getting selected spaces:", error);
    return [];
  }
};

export const normalizeSpaceId = (spaceId: string): string => {
  return spaceId.replace(/\./g, "_").replace(/ /g, "_");
};

export const normalizeSpaceIds = (spaceIds: string[]): string[] => {
  return spaceIds.map(normalizeSpaceId);
};
